import { useEffect } from 'react';
import { useCalendarHeaderContext } from '../../../../../context/calendar-header-context';
import { useCalendarV3ShallowStore } from '../../../../../stores/use-calendar-v3-store';
import { CALENDAR_TRACKING_IDS } from '../../../../../trackingIds/calendar-tracking-ids';
import { CalendarDateSelectorUI } from './calendar-date-selector-ui';

const trackingIds = {
  dateNavigationTodayButton: CALENDAR_TRACKING_IDS.headerBar.dateNavigationTodayButton,
  dateNavigationNextButton: CALENDAR_TRACKING_IDS.headerBar.dateNavigationNextDayButton,
  dateNavigationPrevButton: CALENDAR_TRACKING_IDS.headerBar.dateNavigationPreviousDayButton,
};

export const CalendarDateSelector = () => {
  const { calendarDate, setCalendarDate } = useCalendarV3ShallowStore('calendarDate', 'setCalendarDate');
  const { calendarTodayDate } = useCalendarHeaderContext();

  const onSelectedDateChange = (date: string) => {
    setCalendarDate(date);
  };

  // Initialize calendar date with location's timezone-adjusted today date, when not set
  useEffect(() => {
    if (!calendarDate && calendarTodayDate) {
      setCalendarDate(calendarTodayDate);
    }
  }, [calendarDate, calendarTodayDate, setCalendarDate]);

  return (
    <CalendarDateSelectorUI
      selectedDate={calendarDate}
      todayDate={calendarTodayDate}
      trackingIds={trackingIds}
      onSelectedDateChange={onSelectedDateChange}
    />
  );
};
